export default __webpack_public_path__ + "static/media/Version (7) - Snape Insult - Thumbnail.111fc0b4.png";